// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7fbe3a0d","239":"62033857","455":"b69a9098"}[chunkId] + ".chunk.js";
};